export default __webpack_public_path__ + "static/media/passport.3ff095ef.svg";